export const dom = {
  workspace: document.getElementById('workspace'),
  inputPane: document.getElementById('input-pane'),
  outputPane: document.getElementById('output-pane'),
  inputArea: document.getElementById('input-area'),
  outputArea: document.getElementById('output-area'),
  inputBadge: document.getElementById('input-badge'),
  outputBadge: document.getElementById('output-badge'),
  errorBar: document.getElementById('error-bar'),
  divider: document.getElementById('divider'),
  searchInput: document.getElementById('search-input'),
  searchCount: document.getElementById('search-count'),
  toast: document.getElementById('toast'),
  optSide: document.getElementById('opt-side'),
  optTop: document.getElementById('opt-top'),
  optTypes: document.getElementById('opt-types'),
  optIdx: document.getElementById('opt-idx'),
  themeMenu: document.getElementById('dd-theme'),
};
